import { EDIT_URL, SHOW_HUE_EDIT } from "@/lib/api";

export default function Footer({ onContact }) {
  return (
    <footer data-testid="site-footer" className="bg-[#141310] text-[#8a8272]">
      <div className="max-w-[1500px] mx-auto px-6 md:px-14 pb-14 pt-2">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5 text-[11px] tracking-[0.16em] uppercase">
          <span>&copy; {new Date().getFullYear()} Hue Creative</span>
          <div className="flex items-center gap-8">
            {SHOW_HUE_EDIT && (
              <a data-testid="footer-edit" href={EDIT_URL} target="_blank" rel="noopener noreferrer" className="link-underline hover:text-[#cfc7b8] transition-colors">The Edit</a>
            )}
            <button data-testid="footer-contact" onClick={onContact} className="link-underline hover:text-[#cfc7b8] transition-colors">Contact</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
